

import __layout_0 from '/E:/cm-Project/snw/smil-poms-snw-frontend/src/layouts/default.vue'
export const layouts = {
'auth': () => import('/E:/cm-Project/snw/smil-poms-snw-frontend/src/layouts/auth.vue'),
'default': __layout_0,
'home': () => import('/E:/cm-Project/snw/smil-poms-snw-frontend/src/layouts/home.vue'),
'default-modules/routeSearch': () => import('/E:/cm-Project/snw/smil-poms-snw-frontend/src/layouts/default-modules/routeSearch.vue'),
'english-export-Dialog/english-export-dialog': () => import('/E:/cm-Project/snw/smil-poms-snw-frontend/src/layouts/english-export-Dialog/english-export-dialog.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      meta: route.meta,
      component: layouts[route.meta?.layout || 'default'],
      children: route.path === '/' ? [route] : [{...route, path: ''}]
    }
  })
}
